"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Carrousel = void 0;
var _react = require("react");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _Carrousel = require("./Carrousel.styles");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
const Carrousel = props => {
  const {
    items = [],
    index = 0,
    width
  } = props;
  const {
    direction
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    getMeasurement
  } = (0, _hooks.useStylesUtils)();
  const previousIndexRef = (0, _react.useRef)(null);
  const styles = (0, _Carrousel.useStyles)(props);
  const [containerStyle, setContainerStyle] = (0, _react.useState)('');
  const [incomingStyle, setIncomingStyle] = (0, _react.useState)('');
  const [outgoingStyle, setOutgoingStyle] = (0, _react.useState)('');
  const transitionTimeout = (0, _react.useRef)(null);
  const currentRef = (0, _react.useRef)(null);
  const incomingRef = (0, _react.useRef)(null);
  const outgoingRef = (0, _react.useRef)(null);
  const [currentIndex, setCurrentIndex] = (0, _react.useState)(index);
  const [incomingIndex, setIncomingIndex] = (0, _react.useState)(null);
  const [outgoingIndex, setOutgoingIndex] = (0, _react.useState)(null);

  //initialize current item for the first time
  (0, _react.useEffect)(() => {
    setContainerStyle((0, _css.css)({
      width: width ? getMeasurement(width) : currentRef.current?.clientWidth ?? 'auto',
      height: currentRef.current?.clientHeight ?? 'auto',
      transition: 'width 0s ease-in-out, height 0s ease-in-out'
    }));
  }, [getMeasurement, width]);
  (0, _react.useEffect)(() => {
    setContainerStyle((0, _css.css)({
      width: width ? getMeasurement(width) : 'fit-content',
      height: 'auto'
    }));
    setIncomingStyle((0, _css.css)({}));
    setOutgoingStyle((0, _css.css)({}));
    if (transitionTimeout.current !== null) {
      window.clearTimeout(transitionTimeout.current);
      transitionTimeout.current = null;
    }
    const newIndex = index < 0 || index >= items.length ? index % items.length : index;
    if (previousIndexRef.current !== null) {
      setCurrentIndex(null);
      setIncomingIndex(newIndex);
      setOutgoingIndex(previousIndexRef.current);
    }
    previousIndexRef.current = newIndex;
    transitionTimeout.current = window.setTimeout(() => {
      setCurrentIndex(newIndex);
      setIncomingIndex(null);
      setOutgoingIndex(null);
    }, 510);
  }, [getMeasurement, index, items.length, width]);
  (0, _react.useEffect)(() => {
    if (incomingIndex !== null && outgoingIndex !== null) {
      let animateDirection = direction === 'rtl' && incomingIndex > outgoingIndex || direction !== 'rtl' && incomingIndex <= outgoingIndex ? 'right' : 'left';
      if (incomingIndex === 0 && Math.abs(outgoingIndex) === items.length - 1 || outgoingIndex === 0 && Math.abs(incomingIndex) === items.length - 1) {
        animateDirection = animateDirection === 'right' ? 'left' : 'right';
      }
      setContainerStyle((0, _css.css)({
        width: width ? getMeasurement(width) : outgoingRef.current?.clientWidth ?? 'auto',
        height: outgoingRef.current?.clientHeight ?? 'auto',
        overflow: 'hidden',
        transition: 'width 0s ease-in-out, height 0s ease-in-out'
      }));
      setIncomingStyle((0, _css.css)({
        opacity: 0,
        right: animateDirection === 'right' ? '100%' : 'unset',
        left: animateDirection === 'right' ? 'unset' : '100%'
      }));
      setOutgoingStyle((0, _css.css)({
        opacity: 1,
        left: animateDirection === 'right' ? '0%' : 'unset',
        right: animateDirection === 'right' ? 'unset' : '0%',
        transition: 'opacity .5s ease-in-out, right .5s ease-in-out, left .5s ease-in-out'
      }));
      setTimeout(() => {
        setContainerStyle((0, _css.css)({
          width: width ? getMeasurement(width) : incomingRef.current?.clientWidth ?? 'auto',
          height: incomingRef.current?.clientHeight ?? 'auto',
          overflow: 'hidden',
          transition: 'width .5s ease-in-out, height .5s ease-in-out'
        }));
        setIncomingStyle((0, _css.css)({
          opacity: 1,
          right: animateDirection === 'right' ? '0%' : 'unset',
          left: animateDirection === 'right' ? 'unset' : '0%'
        }));
        setOutgoingStyle((0, _css.css)({
          opacity: 0,
          left: animateDirection === 'right' ? '100%' : 'unset',
          right: animateDirection === 'right' ? 'unset' : '100%'
        }));
      }, 1);
    }
  }, [direction, getMeasurement, incomingIndex, index, items.length, outgoingIndex, width]);
  if (!items.length) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-id": "container",
    className: `${styles['cc-Carrousel']} ${containerStyle}`,
    children: [currentIndex !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-id": "current",
      ref: currentRef,
      className: `${styles['cc-Carrousel__current-item']}`,
      children: items.at(currentIndex)
    }), incomingIndex !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-id": "incoming",
      ref: incomingRef,
      className: `${styles['cc-Carrousel__swapped-item']} ${incomingStyle}`,
      children: items.at(incomingIndex)
    }), outgoingIndex !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-id": "outgoing",
      ref: outgoingRef,
      className: `${styles['cc-Carrousel__swapped-item']} ${outgoingStyle}`,
      children: items.at(outgoingIndex)
    })]
  });
};
exports.Carrousel = Carrousel;